import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export default function HighlightedCard() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <QueryStatsRoundedIcon />
        <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600' }}
        >
          Explore current risks
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: '8px' }}>
          View simulated infrastructure impacts from potential hazards.
        </Typography>
      <Link to="/report" style={{ textDecoration: 'none' }}>
      <Button
        variant="contained"
        size="small"
        color="primary"
        endIcon={<ChevronRightRoundedIcon />}
        fullWidth={isSmallScreen}
      >
        View details
      </Button>
      </Link>
      </CardContent>
    </Card>
  );
}
